import { render, staticRenderFns } from "./ProductBadges.vue?vue&type=template&id=3674d0c2&scoped=true&"
import script from "./ProductBadges.vue?vue&type=script&lang=js&"
export * from "./ProductBadges.vue?vue&type=script&lang=js&"
import style0 from "./ProductBadges.vue?vue&type=style&index=0&id=3674d0c2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3674d0c2",
  null
  
)

export default component.exports